import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

export function Alert({
  label,
  description,
  link,
  variant = 'default',
  startIcon,
  onClose,
}: {
  label: string
  description?: string
  link?: string
  variant?: 'default' | 'success' | 'info' | 'warning' | 'error'
  startIcon?: ReactNode
  onClose: () => void
}) {
  const theme = useTheme()
  const bgColor = {
    default: theme.palette.primary.main,
    success: theme.palette.success.main,
    info: theme.palette.info.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.light,
  }
  return (
    <Box
      display="flex"
      flexDirection="row"
      padding={`${theme.spacing.SM} ${theme.spacing.M}`}
      gap={theme.spacing.SM}
      borderRadius={theme.radius.S}
      bgcolor={bgColor[variant]}
      sx={{
        visibility: label !== '' ? 'visible' : 'hidden',
        '& .MuiSvgIcon-root': { fill: theme.palette.text.inverse, width: theme.size[8], height: theme.size[8] },
      }}
    >
      {startIcon}
      <Box display="flex" flexDirection="column" gap={theme.spacing.S} width="100%">
        <Box
          display="flex"
          flexDirection="row"
          gap={theme.spacing.ML}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body" color={theme.palette.text.inverse}>
            {label}
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>
        {description && (
          <Typography
            onClick={() => {
              if (link) {
                location.href = link
              }
            }}
            sx={{ cursor: link ? 'pointer' : 'default', textDecoration: link ? 'underline' : 'none' }}
            variant="body-small"
            color={theme.palette.text.inverse}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
